import React from 'react';
import '../../../../PublicView/Pages/MyMemberships/AuthorizedMembers/AuthorizedMembers.scss';
import { provideIntlService } from '@progress/kendo-react-intl';
import {
    fetchMembershipUsersByUser,
} from '../../../../../Redux/Actions/Admin/ManageMembershipUserActions';
import { connect } from 'react-redux';


class MembershipsForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            membershipId: this.props.dataItem.membershipId || 0,
            membershipUsersDetails: []
        };

    }

    render() {
        return (
            <React.Fragment>
                <div className="account-tab-content">
                    <div>
                        <div>
                            <h1 className="pt-3 pb-3">Memberships</h1>
                        </div>
                    </div>
                </div>
                {this.props.membershipUsersDetails.length > 0 ?
                    <div className="account-tab-content authorized-members">
                        <div className="table-responsive">
                            <div className="row head">
                                <div className="col-lg-2">
                                    <p>Role</p>
                                </div>
                                <div className="col-lg-2">
                                    <p>Membership Id</p>
                                </div>
                                <div className="col-lg-2">
                                    <p>Renewal Date</p>
                                </div>
                                <div className="col-lg-2">
                                    <p>Type</p>
                                </div>
                                <div className="col-lg-2">
                                    <p>Description</p>
                                </div>
                                <div className="col-lg-2"></div>
                            </div>
                            {this.props.membershipUsersDetails.map((membershipUser) =>
                                <div className="row">
                                    <div className="col-lg-2">
                                        <p>{membershipUser.pending ? "Pending" : membershipUser.invitationType}</p>
                                    </div>
                                    <div className="col-lg-2">
                                        <p>{membershipUser.membershipId}</p>
                                    </div>
                                    <div className="col-lg-2">
                                        <p>{membershipUser.renewalDate.substring(0, 10).replace('/-/g', '/')}</p>
                                    </div>
                                    <div className="col-lg-2">
                                        <p>{membershipUser.membershipType.description}</p>
                                    </div>
                                    <div className="col-lg-2">
                                        <p>{membershipUser.membershipPackage.description}</p>
                                    </div>
                                    <div className="col-lg-2"></div>
                                </div>
                            )}
                        </div>
                    </div>
                    :
                    <div>
                        <p>The User does not have any memberships</p>
                    </div>
                }
                <br/>
                <div className="footer">
                    <div className="form-group">
                        <button className="admin-k-button" onClick={this.props.cancel}>
                            <i className="fas fa-times"></i>
                            <span> CANCEL</span>
                        </button>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        membershipUsersDetails: state.membershipUser.membershipUsersDetails,
    };
}

export default connect(mapStateToProps, {fetchMembershipUsersByUser })(MembershipsForm);